var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachmentCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9998 7.49999L7.99984 12.5M7.99984 7.49999L12.9998 12.5M18.8332 9.99999C18.8332 14.6024 15.1022 18.3333 10.4998 18.3333C5.89746 18.3333 2.1665 14.6024 2.1665 9.99999C2.1665 5.39762 5.89746 1.66666 10.4998 1.66666C15.1022 1.66666 18.8332 5.39762 18.8332 9.99999Z",
    stroke: "#1570EF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachmentCancel);
export default __webpack_public_path__ + "static/media/attachmentCancel.60b1d28d0f2820ca8f0f2f17464ea32d.svg";
export { ForwardRef as ReactComponent };